import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import './dlist.scss';

@Component
export default class DList extends Vue {
  @Prop({ required: true }) items;
  @Prop({ required: true, type: String, default: 'id' }) primaryKey;
  @Prop({ required: true, type: String, default: 'label' }) labelKey;
  @Prop({ type: Boolean, default: false }) clickable;
  @Prop({ type: Boolean, default: true }) removable;


  onDelete(event, item) {
    event.stopPropagation();
    event.preventDefault();

    this.$emit('delete', item);
  }

  onItemClick(event, item) {
    this.$emit('item_click', item);
  }

  render(createElement) {
    return <div class="cmp-dtplugins-dlist dt-list v2">
      {this.items && this.items.map(item => (
        <div class={`dt-list-item `}
          key={item[this.primaryKey]}
          onClick={e => this.onItemClick(e, item)}
        >
          <div class="dt-list-item--body">
            <div class={`dt-list-item--text ${this.clickable ? 'clickable' : ''}`}>
              <span>{item[this.labelKey]}</span>
            </div>
            <div class="dt-list-item--icon">
              <div class="dt-icon-container">
                {this.removable ? <img
                  src="static/icons/delete.svg"
                  onClick={e => this.onDelete(e, item)}
                  class="dt-icon v5 s1"
                  alt="" /> : <div style="width: 25px; height: 1px"></div>}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  }
}